import { getAnonymousToken, getMemberToken } from 'shared/src/utils';
import { safeLocalStorage } from '@toss/storage';
import type { InternalAxiosRequestConfig } from 'axios';
import uuid from 'react-native-uuid';

const SLASH = '/';
const SELLER_API = ['/seller/accounts/minimal_market_info/'];

const hasQueryParams = (url: string) => {
  return url.includes('?');
};
const isLastCharSlash = (url: string) => {
  return url[url.length - 1] === SLASH;
};

const addSlash = (url: string) => {
  const addSlash = !hasQueryParams(url) && !isLastCharSlash(url);

  if (addSlash) {
    return `${url}${SLASH}`;
  }
  return url;
};

const isMobile = () => {
  const regex = /Android|iPhone|iPad/i;
  return regex.test(navigator.userAgent);
};

const getDeviceId = () => {
  const DEVICE_ID_KEY = 'device-id';

  const deviceId = safeLocalStorage.get(DEVICE_ID_KEY);
  if (deviceId) {
    return deviceId;
  }

  const newDeviceId = uuid.v4();
  safeLocalStorage.set(DEVICE_ID_KEY, newDeviceId);

  return newDeviceId;
};

export const requestSetHeadersInterceptor = async (
  config: InternalAxiosRequestConfig,
) => {
  config.headers = config.headers ?? {};
  if (config.url) {
    config.url = addSlash(config.url);
  }
  const memberToken = await getMemberToken();
  const { headers } = config;

  if (config.url && !SELLER_API.includes(config.url)) {
    if (memberToken) {
      headers['Authorization'] = `JWT ${memberToken}`;
    } else {
      const anonymousToken = await getAnonymousToken(config.baseURL);
      if (anonymousToken) {
        headers['X-Anonymous-Token'] = `${anonymousToken}`;
      }
    }
  }

  headers['X-Device-Type'] = isMobile() ? 'MobileWeb' : 'PCWeb';
  headers['X-App-Version'] = '0.1.0';
  headers['X-Web-Type'] = 'Web';
  headers!['X-Device-Id'] = getDeviceId();

  return config;
};
